import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PostDataService } from 'src/app/shared/services/post-data.service';
import { AutoUnsubscribeComponent } from 'src/app/shared/utils/auto-unsubscribe.component';

@Component({
  selector: 'app-code-validation',
  templateUrl: './code-validation.component.html',
  styleUrls: ['./code-validation.component.scss'],
})
export class CodeValidationComponent
  extends AutoUnsubscribeComponent
  implements OnInit
{
  public applicationId!: string;
  public token!: string;
  public viewTemplate = false;
  public viewVerificationValid = false;
  public viewVerificationIncorrect = false;
  public textCodeEmailVerification!: string;
  public textVerificationValid!: string;
  public textVerificationInvalid!: string;

  constructor(
    private postDataService: PostDataService,
    private activatedRouter: ActivatedRoute
  ) {
    super();

    this.activatedRouter.queryParams.subscribe((params) => {
      this.applicationId = params['applicationId'];
      this.token = params['token'];
    });
  }

  ngOnInit(): void {
    const pathname = window.location.pathname;
    if (pathname === '/verificacion-codigo') {
      this.textCodeEmailVerification = 'Estamos verificando el código.';
      this.textVerificationValid = 'Su código fue verificado correctamente.';
      this.textVerificationInvalid =
        'Su código no pudo ser verificado correctamente.';
      this.verificationCode();
    }

    if (pathname === '/verificacion-email') {
      this.textCodeEmailVerification = 'Estamos verificando su email.';
      this.textVerificationValid = 'Su email fue verificado correctamente.';
      this.textVerificationInvalid =
        'Su email no pudo ser verificado correctamente.';
      this.verificationMail();
    }
  }

  verificationCode() {
    const postContactVerification$ = this.postDataService
      .postContactVerification(this.applicationId, this.token)
      .subscribe({
        next: () => {
          this.viewTemplate = true;
          this.viewVerificationValid = true;
        },
        error: () => {
          this.viewTemplate = true;
          this.viewVerificationIncorrect = true;
        },
      });
    this.subscriptions.push(postContactVerification$);
  }

  verificationMail() {
    const postMailVerification$ = this.postDataService
      .postMailVerification(this.applicationId, this.token)
      .subscribe({
        next: () => {
          this.viewTemplate = true;
          this.viewVerificationValid = true;
        },
        error: () => {
          this.viewTemplate = true;
          this.viewVerificationIncorrect = true;
        },
      });
    this.subscriptions.push(postMailVerification$);
  }
}
